import api from './api';

export const statsApi = {
  // Get dashboard stats
  getDashboard: () => api.get('/stats/dashboard'),

  // Get visit history
  getVisitHistory: (period = 'hour', limit = 24) =>
    api.get(`/stats/visits?period=${period}&limit=${limit}`),

  // Get media stats
  getMediaStats: () => api.get('/stats/media'),

  // Get HTTP logs
  getHTTPLogs: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);
    if (params.start) queryParams.append('start', params.start);
    if (params.end) queryParams.append('end', params.end);
    if (params.uri_path) queryParams.append('uri_path', params.uri_path);
    if (params.method) queryParams.append('method', params.method);
    if (params.status) queryParams.append('status', params.status);
    if (params.user_id) queryParams.append('user_id', params.user_id);

    return api.get(`/stats/http-logs?${queryParams.toString()}`);
  },

  // Get HTTP stats
  getHTTPStats: () => api.get('/stats/http-stats'),
};
